(function($){
    'use strict';

    var 
        $html = $('html'),
    	$body = $('body'),
    	$headerToggle = $('.js-header-toggle button'),
        $headerTabbingElements = $('.js-header-taborder'),
    	$navigation = $('.js-navigation'),
    	$navigationClose = $navigation.find('.js-navigation-close'),
    	$navigationOpen = $navigation.find('.js-navigation-open'),
    	$navigationBack = $navigation.find('.js-navigation-back'),
    	$navigationToggle = $navigation.find('.js-navigation-toggle'),
    	$navigationLink = $navigation.find('.js-navigation-link'),
        $subNavigations = $navigation.find('.js-navigation-lvl2'),

    	navigationSpaceState = true;

    // $headerToggle.click(function() {
    // 	if($headerToggle.hasClass('active')) {
    // 		closeNavigation();
    // 	} else {
    // 		openNavigation();
    // 	}

    // 	return false;
    // });

    $headerToggle.on('click', function() {
        if($headerToggle.hasClass('active')) {
            closeNavigation();
        } else {
            openNavigation();
        }

        return false;
    });

    $navigationClose.click(function() {
		closeNavigation();
    });

    $navigationOpen.each(function() {
    	var $openButton = $(this),
    		$subNavigation = $openButton.closest('li').find('.js-navigation-lvl2');

    	$openButton.closest('div').addClass('parent');

    	$openButton.click(function() {
	    	$subNavigation.addClass('active');
	    	$navigation.addClass('shifted');
	    	$navigationClose.addClass('fixed');
	    });
    });

    $navigationBack.each(function() {
    	var $backButton = $(this),
    		$subNavigation = $backButton.closest('.js-navigation-lvl2');

    	$backButton.click(function() {
	    	$navigation.removeClass('shifted');
			setTimeout(function(){
	    		$subNavigation.removeClass('active');
	    		$navigationClose.removeClass('fixed');
			}, 300);
	    });
    });

    $navigationToggle.each(function() {
    	var $toggleButton = $(this),
            $toggleItem = $toggleButton.closest('li'),
    		$subNavigation = $toggleItem.find('.js-navigation-lvl3'),
            $toggleLink = $toggleButton.siblings('a');

        if($subNavigation.length) {
            $toggleButton.closest('div').addClass('parent');
            
            $toggleButton.click(function() {
                if($toggleButton.hasClass('active')) {
                    $toggleButton.removeClass('active');
                    $subNavigation.slideUp(300, function() {
                        $subNavigation.removeAttr('style').removeClass('active');
                    });
                } else {
                    $toggleButton.addClass('active');
                    $subNavigation.slideDown(300, function() {
                        $subNavigation.addClass('active').removeAttr('style');
                    });
                }
            });

            $toggleLink.keyup(function(evt) {// Open/Close level 3 navigation when using keyboard
                if(!$headerToggle.is(':visible')) {
                    if (evt.keyCode == 32 || evt.keyCode == 13) {
                        navigationSpaceState = false;
                    }
                }
            }).keydown(function(evt) {
                if(!$headerToggle.is(':visible')) {
                    if (evt.keyCode == 32 || evt.keyCode == 13) {
                        navigationSpaceState = true;
                        
                        if($toggleItem.hasClass('open')) {
                            $toggleItem.removeClass('open');
                            $subNavigation.removeClass('active');
                        } else {
                            $navigationToggle.closest('li').removeClass('open');
                            $navigation.find('.js-navigation-lvl3').removeClass('active');
                            $toggleItem.addClass('open');
                            $subNavigation.addClass('active');
                            adjustNavigationHeight($subNavigation);
                        }

                        return false;
                    }
                }
            }).on('touchstart', function(){ // Open level 3 navigation on large touch devices
                if(!$headerToggle.is(':visible')) {
                    if(!$toggleItem.hasClass('open')) {
                        $navigationToggle.closest('li').removeClass('open');
                        $navigation.find('.js-navigation-lvl3').removeClass('active');
                        $toggleItem.addClass('open');
                        $subNavigation.addClass('active');
                        adjustNavigationHeight($subNavigation);
                        return false;
                    }
                }
            });

            $toggleItem.hover(function(){
                if($html.hasClass('no-touch') && !$headerToggle.is(':visible')) {
                    $navigation.addClass('hover');
                    adjustNavigationHeight($subNavigation);
                }
            }, function(){
                $navigation.removeClass('hover');
                if($html.hasClass('no-touch') && !$headerToggle.is(':visible')) {
                    setTimeout(function(){
                        if(!$navigation.hasClass('hover')) {
                            adjustNavigationHeight();
                        }
                    }, 50); //Accounting for the delay between hover events on two items
                }
            });
        } else {
            $toggleButton.remove();
        }
    });

    $navigationLink.each(function() {
    	var $link = $(this),
    		$subNavigation = $link.closest('li').find('.js-navigation-lvl2');

    	$link.keyup(function(evt) {// Open/Close level 2 navigation when using keyboard
	        if(!$headerToggle.is(':visible')) {
                if (evt.keyCode == 32 || evt.keyCode == 13) {
                    navigationSpaceState = false;
                }
            }
        }).keydown(function(evt) {
            if(!$headerToggle.is(':visible')) {
                if (evt.keyCode == 32 || evt.keyCode == 13) {
                    navigationSpaceState = true;
                    
                    if($link.hasClass('open')) {
                        $link.removeClass('open');
                        $subNavigation.removeClass('open');
                    } else {
                    	$navigation.find('.open').removeClass('open');
                        $link.addClass('open');
                        $subNavigation.addClass('open');
                    }

                    return false;
                }
            }
        }).on('touchstart', function(){ // Open/Close level 2 navigation on large touch devices
            if(!$headerToggle.is(':visible')) {
                if($link.hasClass('open')) {
                    $link.removeClass('open');
                    $subNavigation.removeClass('open');
                } else {
                    $navigationLink.removeClass('open');
                    $subNavigations.removeClass('open');
                    $link.addClass('open');
                    $subNavigation.addClass('open');
                }

                return false;
            }
         });
    });

    function adjustNavigationHeight($navigationItem) {
        if($navigationItem) {
            var $navigationParent = $navigationItem.closest('.js-navigation-lvl2');

            $navigationItem.removeAttr('style');
            $navigationParent.removeAttr('style');

            var navigationHeight = $navigationItem.outerHeight(),
                navigationParentHeight = $navigationParent.height();

            if(navigationHeight > navigationParentHeight) {
                $navigationParent.height(navigationHeight);
            } else {
                $navigationItem.height('100%');
            }
        } else {
            $subNavigations.removeAttr('style');
        }

    }

    function openNavigation() {
		$headerToggle.addClass('active');
		$navigation.addClass('active').on('click', stopNavigation);
		$body.addClass('navigation-open').addClass('navigation-fixed').on('click', closeNavigation); 
        $headerTabbingElements.find('a, button').attr('tabindex', '-1');
    }

    function closeNavigation() {
		$headerToggle.removeClass('active');
		$navigationClose.removeClass('fixed');
		$navigation.removeClass('active').off('click', stopNavigation); 
		$body.removeClass('navigation-open').off('click', closeNavigation);	
        $headerTabbingElements.find('a, button').removeAttr('tabindex');
		setTimeout(function(){
			$body.removeClass('navigation-fixed');
			$navigation.removeClass('shifted');
			$navigation.find('.active').removeClass('active'); 
		}, 300);
    }

    function stopNavigation(e) {
    	e.stopPropagation();
    }
    
}(jQuery));